import im from 'immutable';
import createActions from './entity/create-actions';
import createController from './entity/create-controller';

const ResourceState = im.Record({
  pending: true,
  error: undefined,
  data: undefined,
});

function getResource(type, id) {
  return state => state[type] && state[type].get(id);
}

function isResourcePending(type, id) {
  return state => {
    // TODO: Is this the best way to solve this? Maybe we should have different
    //       pending states based on which operation it is. Maybe go from a
    //       single pending boolean to a status type field where we can have
    //       more granular control.
    const hasOperation = !!state.operation.find(
      r => r.indexOf(`${type}/`) !== -1 && r.indexOf(id) !== -1 && r.indexOf('read') > -1
    );
    const doesExist = getResource(type, id)(state);
    const isPending = hasOperation || (!hasOperation && !doesExist);
    return isPending;
  };
}

function getFirstErrorOrNull(type, id) {
  return state => {
    const firstError = state.error.find(
      r => r.id.indexOf(`${type}/`) !== -1 && r.id.indexOf(id) !== -1
    );
    return firstError ? firstError.error : null;
  };
}

export function selectResource(resourceTypeName, id) {
  return state =>
    new ResourceState({
      data: getResource(resourceTypeName, id)(state),
      pending: isResourcePending(resourceTypeName, id)(state),
      error: getFirstErrorOrNull(resourceTypeName, id)(state),
    });
}

export default (Schema, controller = {}) => {
  const Actions = createActions(Schema);

  return createController(Actions, Schema, {
    Actions,
    storeSelector: selectResource,
    getState: () => {
      throw new Error(`getState: Not implemented for ${Schema.name}`);
    },
    ...controller,
  });
};
